export const HEADER_FIRST_LINE = {
  class: 'font-weight-bold primary--text',
  style: 'font-size: 14px;',
};

export const HEADER_SECOND_LINE = {
  class: 'font-weight-regular primary--text',
  style: 'font-size: 14px;',
};

export const REQUEST_FIRST_LINE = {
  class: 'font-weight-bold foreground-accent--text',
  style: 'font-size: 14px;',
};

export const REQUEST_SECOND_LINE = {
  class: 'font-weight-regular foreground-accent--text',
  style: 'font-size: 14px;',
};

export const BODY_FIRST_LINE = {
  class: 'font-weight-regular foreground--text',
  style: 'font-size: 14px;',
};

export const BODY_SECOND_LINE = {
  class: 'font-weight-light foreground--text',
  style: 'font-size: 14px;',
};

export const BODY_SECOND_LINE_STATUS = {
  class: 'font-weight-light muted-accent--text d-flex justify-start',
  style:
    'font-size: 14px; color: var(--v-muted-accent-base) !important; background: var(--v-muted-immutable-base) 0% 0% no-repeat padding-box; border-radius: 10px; padding: 0 14px;',
};

export const SELECT_FOOTER = {
  style: "max-width: 80px; width: 80px; margin-right: 50px; font-size: 14px;",
}

export const LABEL_FOOTER = {
  class: 'font-weight-regular foreground--text',
  style: "font-size: 14px; margin-right: 50px; ",
}